import React, { useState, useEffect, useRef } from "react";
import userResources from "api/userResources"; // Replace with your API methods
import UserInfoModal from "components/UserInfoModal/UserInfoModal";
import { IoClose, IoSend } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { chatBotImg, avtar } from "utils/images";
import { selectUserInfo } from "../../../../redux/userSlice";
import msgSoundSound from "../../../../assets/Sound/send.mp3";
import notificationSound from "../../../../assets/Sound/notification.wav";
import { FaBars, FaSearch } from "react-icons/fa";
import { addMessage } from "../../../../redux/messageSlice";
import { motion } from "framer-motion";
export default function ChatApp({ toggleChat }) {
  const dispatch = useDispatch();
  const reduxMessages = useSelector((state) => state?.messages);
  const userInfo = useSelector(selectUserInfo);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [user, setUser] = useState();
  const [forceUpdate, setForceUpdate] = useState(0);
  const [disable, setDisable] = useState(false);
  const [userSearch, setUserSearch] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    selectedUser ? false : true
  );

  // Laravel Echo setup
  useEffect(() => {
    setForceUpdate((prev) => prev + 1);
  }, [selectedUser, reduxMessages]);

  const handleOpenModal = (assignedUser) => {
    setUserProfile(assignedUser);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setUserProfile({});
  };

  const usersList = async () => {
    const params = {
      name: userSearch, // Assuming `userSearch` holds the search value
    };

    try {
      const res = await userResources.adminemployeeslist(0, 9999, params); // Passing the parameters here
      if (res.status) {
        const filteredUsers = res.data.data.filter(
          (e) => e.id !== userInfo.data.id
        );
        setUsers(filteredUsers);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  // Fetch chat messages from the server
  const fetchMessages = (() => {
    let currentAbortController = null; // Store the current AbortController

    return async (userId) => {
      // Abort the previous request if it's still ongoing
      if (currentAbortController) {
        currentAbortController.abort();
      }

      // Create a new AbortController for the current request
      currentAbortController = new AbortController();
      const signal = currentAbortController.signal;

      const data = {
        receiver: userId,
      };

      try {
        const res = await userResources.getChatMessages(data, { signal });

        if (res.status) {
          setMessages(res.data);
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Previous request aborted due to new request.");
        } else {
          console.error("Error fetching messages:", error);
        }
      }
    };
  })();

  // Handle user selection
  const handleUserSelection = () => {
    if (user) {
      setSelectedUser(user);
      fetchMessages(user.id); // Ensure user.id is available before calling fetchMessages
    }
  };

  useEffect(() => {
    handleUserSelection();
  }, [user]); // Only re-run when `user` changes

  // Send message
  const sendMessage = async () => {
    setDisable(true);
    if (selectedUser && newMessage.trim()) {
      const messageData = {
        message: newMessage, // The message content
        receiver_id: selectedUser.id, // The receiver's user ID
      };

      try {
        const res = await userResources.sendMsg(messageData);
        if (res.status) {
          // Play sound when the message is successfully sent
          const audio = new Audio(msgSoundSound);
          audio.play();

          handleUserSelection();
          // fetchMessages(user?.id);
          setMessages((prevMessages) => [
            ...prevMessages,
            { ...messageData, sender: "You" },
          ]);
          setNewMessage(""); // Clear the input field
          setDisable(false);
        }
      } catch (error) {
        setDisable(false);
        console.error("Error sending message:", error);
      }
      setDisable(false);
    }
  };

  function parseMessage(message) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Helper function to split long words
    const splitLongWords = (text) => {
      const maxChar = 20;
      if (text.length <= maxChar) {
        return text;
      }

      // Split into chunks of `maxChar` characters and join with a newline
      const chunks = text.match(new RegExp(`.{1,${maxChar}}`, "g"));
      return chunks.join("\n");
    };

    return message.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="break-all text-white underline"
        >
          {splitLongWords(part)}
        </a>
      ) : (
        // Process non-URL text to split long words
        splitLongWords(part)
      )
    );
  }
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  }

  useEffect(() => {
    usersList();
  }, []);

  useEffect(() => {
    usersList();
  }, [reduxMessages]);

  useEffect(() => {
    // Set a timeout to delay the function execution by 2 seconds
    const timer = setTimeout(() => {
      usersList(); // Call the usersList function after 2 seconds
    }, 300);

    // Cleanup function to clear the timeout if the userSearch changes before 2 seconds
    return () => clearTimeout(timer);
  }, [userSearch]); // The effect will run when userSearch changes

  useEffect(() => {
    fetchMessages(user?.id); // Uncomment if necessary
    setForceUpdate(0);
  }, [forceUpdate, reduxMessages]);

  useEffect(() => {
    if (selectedUser) {
      setIsSidebarOpen(false);
    }
  }, [selectedUser]);

  // useEffect(() => {
  //   fetchMessages(user?.id); // Uncomment if necessary
  // }, [forceUpdate, reduxMessages]);

  // const chatEndRef = useRef(null);

  // const scrollToBottom = () => {
  //   // chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  // };

  // useEffect(() => {
  //   scrollToBottom();
  // }, [messages]);

  const listContainerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1, // Controls the delay between items
      },
    },
  };

  const listItemVariants = {
    hidden: { opacity: 0, x: -50 }, // Start off-screen to the left
    show: { opacity: 1, x: 0 }, // Slide into view
  };

  return (
    // <section>
    <div className="grid h-screen grid-cols-3 sm:h-auto sm:grid-cols-5">
      <div
        className={`relative -left-3 z-30 col-span-2 bg-gray-900 bg-gradient-to-b p-4 text-white transition-all duration-300 sm:left-0 sm:col-span-2 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full sm:translate-x-0"
        } sm:block`}
      >
        <div className="relative w-full">
          <input
            type="text"
            value={userSearch}
            placeholder="Search..."
            className="input mb-2 w-full bg-white pr-10 text-gray-900"
            onChange={(e) => setUserSearch(e.target.value)}
          />
          <FaSearch className="absolute right-3 top-6 -translate-y-1/2 transform text-gray-900" />
        </div>
        <ul
          className={`hide-scroll-bar relative ${
            selectedUser ? "h-[80vh]" : "h-[85vh]"
          } overflow-y-scroll sm:h-[54vh]`}
        >
          {users.length > 0 ? (
            <motion.div
              className="space-y-2"
              variants={listContainerVariants}
              initial="hidden"
              animate="show"
            >
              {users.map((user) => {
                const userMessages = reduxMessages.filter(
                  (message) => message.sender_id === user.id
                );
                const lastMessage =
                  userMessages.length > 0
                    ? userMessages[userMessages.length - 1].message
                    : "No messages yet";

                return (
                  <motion.div
                    key={user.id}
                    className={`flex cursor-pointer items-center gap-2 rounded p-2 hover:bg-[#bb8e25] hover:text-white ${
                      selectedUser?.id === user.id ? "bg-[#bb8e25]" : ""
                    }`}
                    onClick={() => {
                      setUserSearch("");
                      setUser(user);
                    }}
                    variants={listItemVariants}
                  >
                    <div className="tooltip" data-tip="Profile">
                      <motion.img
                        whileHover={{ scale: 1.1 }}
                        onClick={() => handleOpenModal(user)}
                        className="h-10 w-12 cursor-pointer rounded-full"
                        src={user?.full_path || avtar}
                        alt={user?.name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = avtar;
                        }}
                      />
                    </div>

                    <motion.div className=" w-full">
                      <div className="flex items-center gap-2">
                        <p className="text-sm">{user?.name}</p>
                        {/* Login Status */}
                        {/* <p
                          className={`${
                            user?.user_login === 1
                              ? "text-green-500"
                              : "text-red-500 "
                          } flex items-center gap-2 `}
                        >
                          <motion.span
                            className="relative h-2 w-2 rounded-full bg-current"
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{
                              type: "spring",
                              stiffness: 200,
                              damping: 10,
                            }}
                          ></motion.span>
                        </p> */}
                      </div>
                      <p
                        className={`inline-block w-full text-sm hover:text-white ${
                          selectedUser?.id === user.id
                            ? "text-white "
                            : "text-[#bb8e25] "
                        }`}
                      >
                        {lastMessage.length > 20
                          ? lastMessage.slice(0, 20) + "..."
                          : lastMessage}
                      </p>
                    </motion.div>
                  </motion.div>
                );
              })}
            </motion.div>
          ) : null}
          <div className="absolute bottom-0 block w-full sm:hidden">
            <button
              className="btn w-full bg-red-500 py-0 text-white hover:bg-red-600"
              onClick={() => {
                toggleChat();
              }}
            >
              Close
            </button>
          </div>
        </ul>
      </div>
      <div className="absolute top-0 col-span-3 h-full w-full bg-white p-0 sm:relative sm:col-span-3 ">
        {selectedUser ? (
          <div className="">
            <div className="absolute top-0 z-20 flex w-full items-center justify-between bg-gray-900">
              <div className=" flex items-center gap-2 p-2.5">
                {/* Animated Avatar */}
                <motion.img
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  onClick={() => handleOpenModal(selectedUser)}
                  className="h-10 w-10 cursor-pointer rounded-full"
                  src={user?.full_path}
                  alt={user?.name || "User Avatar"}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = avtar;
                  }}
                />

                {/* Animated Text Section */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <div className="flex items-center gap-2">
                    <p className="font-semibold capitalize text-[#bb8e25]">
                      {selectedUser.name}
                    </p>
                    <p
                      className={`${
                        selectedUser?.user_login === 1
                          ? "text-green-500"
                          : "text-red-500"
                      } flex items-center gap-2`}
                    >
                      <motion.span
                        className="relative h-2 w-2 rounded-full bg-current"
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{
                          type: "spring",
                          stiffness: 200,
                          damping: 10,
                        }}
                      ></motion.span>
                      {/* {selectedUser.user_login} */}
                    </p>
                  </div>

                  <p className="text-sm font-semibold capitalize text-gray-300">
                    {selectedUser.phone_no}
                  </p>
                </motion.div>
              </div>
              {/* Hamburger Icon */}
              {isSidebarOpen === true ? (
                <div className="p-4 sm:hidden">
                  <IoClose
                    className="cursor-pointer text-white hover:text-red-500"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)} // Toggle sidebar
                    size={25}
                  />
                </div>
              ) : (
                <div className="p-4 sm:hidden">
                  <FaBars
                    className="cursor-pointer text-white"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)} // Toggle sidebar
                    size={25}
                  />
                </div>
              )}
            </div>
            <div className="absolute bottom-0 w-full">
              <div className="relative mt-4 flex h-[75vh] flex-col-reverse overflow-y-auto rounded-lg p-4 sm:h-[45vh]">
                {messages
                  ?.sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at)
                  )
                  ?.map((msg, id) => (
                    <div
                      key={id}
                      className={`mb-3 flex flex-wrap ${
                        msg?.sender_id !== userInfo?.data?.id
                          ? "justify-start"
                          : "justify-end"
                      }`}
                    >
                      <div
                        className={`relative flex max-w-[80%] flex-col rounded-2xl px-4 py-2 shadow-md ${
                          msg?.sender_id !== userInfo?.data?.id
                            ? "bg-[#F0F0F3] text-[#333333]" // receiver
                            : "self-end bg-[#D1E8FF] text-[#084C61]" // sender
                        }`}
                      >
                        <span className="break-words text-[15px] font-medium leading-snug">
                          {parseMessage(msg?.message)}
                        </span>
                        <span className="mt-1 self-end text-[11px] text-[#999999]">
                          {formatDateTime(msg?.created_at)}
                        </span>
                      </div>
                    </div>
                  ))}
                {/* <div ref={chatEndRef} /> */}
                <div />
              </div>
              <div className="relative z-40 flex w-full items-center gap-4 bg-white p-2">
                <div className="relative w-full ">
                  <input
                    type="text"
                    disabled={disable} // Correctly use 'disabled'
                    value={newMessage} // Value remains the message text
                    onChange={(e) => setNewMessage(e.target.value)} // Handle input changes
                    className={`input w-full border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                      disable ? "pointer-events-none" : ""
                    }`}
                    placeholder={
                      disable ? "Loading..." : "Type your message..."
                    } // Optional placeholder change
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !disable) {
                        sendMessage();
                      }
                    }}
                    style={{
                      backgroundColor: disable ? "#f5f5f5" : "#ffffff", // Ensure the background stays consistent
                      cursor: disable ? "default" : "text", // Prevent the "not-allowed" cursor
                    }}
                  />
                  {disable && (
                    <span className="loading loading-dots loading-xs absolute right-2 top-1/2 -translate-y-1/2 transform">
                      ...
                    </span>
                  )}
                </div>
                <button
                  className="cursor-pointer rounded-full bg-blue-500 p-3 "
                  disabled={!newMessage}
                  onClick={sendMessage}
                >
                  <IoSend size={20} className="text-white" />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="flex h-full w-full items-center justify-center bg-cover bg-center"
            style={{ backgroundImage: `url(${chatBotImg})` }}
          ></div>
        )}
        <div>
          {isModalOpen && (
            <UserInfoModal user={userProfile} onClose={handleCloseModal} />
          )}
        </div>
      </div>
    </div>

    // {/* </section> */}
  );
}
